import { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, LinkButton } from '@evertrue/et-components';
import EnrichmentModalHeader from './enrichment-modal-header';
import EnrichmentList from './enrichment-list';

/**
 * Modal for viewing and managing all philanthropic indicators (Leadership/Involvement and Interests).
 */
const PhilanthropicIndicatorsModal = ({
  isOpen,
  closeModal,
  onDelete,
  wealthIndicators = [],
  philInterests = [],
  contactAttributes,
}) => {
  const [showRejected, setShowRejected] = useState(false);

  const activeWealthIndicators = wealthIndicators.filter(({ rejected }) => !rejected);
  const rejectedWealthIndicators = wealthIndicators.filter(({ rejected }) => rejected);
  const activePhilInterests = philInterests.filter(({ rejected }) => !rejected);
  const rejectedPhilInterests = philInterests.filter(({ rejected }) => rejected);

  const hasRejectedItems = rejectedWealthIndicators.length > 0 || rejectedPhilInterests.length > 0;

  return (
    <Modal isOpen={isOpen} closeModal={closeModal} size="500px">
      <EnrichmentModalHeader
        headerText={`${contactAttributes?.contactName}'s Philanthropic Indicators`}
        closeModal={closeModal}
      />
      <div className="profile-enrichment--more-modal">
        {activeWealthIndicators.length > 0 && (
          <EnrichmentList
            title="Leadership and Involvement"
            list={activeWealthIndicators}
            accessor="type"
            limit={activeWealthIndicators.length}
            contactId={contactAttributes?.contactId}
            onDelete={onDelete}
            showActions
          />
        )}
        {activePhilInterests.length > 0 && (
          <EnrichmentList
            title="Philanthropic Interests"
            list={activePhilInterests}
            accessor="interest_name"
            limit={activePhilInterests.length}
            contactId={contactAttributes?.contactId}
            onDelete={onDelete}
            showActions
          />
        )}

        {hasRejectedItems && (
          <LinkButton onClick={() => setShowRejected(!showRejected)} title="">
            {showRejected ? 'Hide deleted' : 'See deleted'}
          </LinkButton>
        )}

        <div style={{ marginTop: '15px' }}>
          {showRejected && rejectedWealthIndicators.length > 0 && (
            <EnrichmentList
              title="Leadership and Involvement"
              list={rejectedWealthIndicators}
              accessor="type"
              limit={rejectedWealthIndicators.length}
              contactId={contactAttributes?.contactId}
              onDelete={onDelete}
              showActions
            />
          )}
          {showRejected && rejectedPhilInterests.length > 0 && (
            <EnrichmentList
              title="Philanthropic Interests"
              list={rejectedPhilInterests}
              accessor="interest_name"
              limit={rejectedPhilInterests.length}
              contactId={contactAttributes?.contactId}
              onDelete={onDelete}
              showActions
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

PhilanthropicIndicatorsModal.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  onDelete: PropTypes.func,
  wealthIndicators: PropTypes.array,
  philInterests: PropTypes.array,
  contactAttributes: PropTypes.object,
};

export default PhilanthropicIndicatorsModal;
